/**
 * "Reading notes" on a filed document (owner decision 11 Oct 2026, filedDocumentConflictsAsNotes): points the automatic reading of the
 * original flagged that are not being asked as a question. Shown as they were read; correct a detail on the document if it is wrong.
 */
export function DocumentReadingNotes({notes}:{notes?:string[]|undefined}){
 if(!notes?.length)return null;
 return <details className="document-reading-notes" aria-label="Reading notes"><summary>Reading notes ({notes.length})</summary>
  <p>Notes from automatic reading. Check them against the original before relying on them.</p>
  <ul>{notes.map((note,index)=><li key={index}>{note}</li>)}</ul>
 </details>;
}
